<template>
  <div ref="emptyPage" class="empty-page">
    <div>
      <van-image
        :width="pxTovw(500)"
        :height="pxTovw(320)"
        :src="bgCourseEmpty"
        class="bg-course-empty"/>
    </div>
    <span class="course-empty-text" v-html="emptyText"/>

  </div>
</template>

<script>
import { Image as VanImage, Overlay, Toast, Popup, Button } from 'vant';

export default {
  components: {
    [VanImage.name]: VanImage,
    [Overlay.name]: Overlay,
    [Toast.name]: Toast,
    [Popup.name]: Popup,
    [Button.name]: Button
  },
  props: {
    emptyText: {
      type: String,
      default: ''
    },
    bgCourseEmpty: {
      type: String,
      default: require('../../assets/img/course/bg-course-empty.png')
    },
    showOrderPay: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      payTypeList: [
        {
          payTypeIcon: require('../../assets/img/order/icon-allpay.png'),
          payTypeName: '聚合支付',
          isChosed: false
        }
      ],
      payDisabled: true,
      payChosed: require('../../assets/img/order/icon-checkbox-chosed.png'),
      payUnChosed: require('../../assets/img/order/icon-checkoubox-unchosed.png'),
      iconClose: require('../../assets/img/course/icon-school-close.png')
    };
  },
  methods: {

  }
};
</script>

<style scoped lang="scss">
.empty-page {
  text-align: center;

  .bg-course-empty {
    padding-top: 216px;
    box-sizing: content-box;
    margin-left: auto;
    margin-right: auto;
  }

  .course-empty-text {
    width: fit-content;
    height: 40px;
    font-size: 28px;
    font-family: $font-Regular;
    font-weight: 400;
    color: #b0b0b0;
    line-height: 40px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 4px;
  }
}

.single-line {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.mt40 {
  margin-top: 40px;
}

.dash-line {
  width: 100%;
  height: 2px;
  background: #e0e0e0;
  opacity: 0.5;
}

.opacity-gray {
  opacity: 0.45;
  color: #000 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/order/emptyPage.vue